import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import _ from '@lodash';
import type { RootState } from 'app/store';
import { EntraState, EntraActionTypes } from 'app/store/types';

const initialState: EntraState = {};

const entraReducer = (state = initialState, action: EntraActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_START':
			return {
				...state,
				loading: true,
				error: null
			};

		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				data: { settingSSO }
			} = action.payload;

			return {
				...state,
				settingSSO,
				loading: false,
				error: null
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'settingSSO',
		storage: localForage
	},
	entraReducer
);

// Selectors
export const getEntraSettings = ({ entra }: RootState) => entra.settingSSO;
export const getEntraSettingsLoading = ({ entra }: RootState) => entra.loading;
